import {
  Table,
  TableRow,
  TableHead,
  TableCell,
  TableBody,
  ListItemText,
  TableContainer,
} from '@mui/material';
import { PositionTxType } from 'src/type/position';
import { convertGold } from 'src/utils/convert';
import { fNumber } from 'src/utils/format-number';

type Props = {
  isOrnament: boolean;
  infos: {
    buyAmount: number;
    sellAmount: number;
    netAmount: number;
    buyTotal: number;
    sellTotal: number;
    netTotal: number;
  };
  userTransactions: PositionTxType[];
};

export default function OpenedPositionTable({ isOrnament, infos, userTransactions }: Props) {
  const averagePrice = () => {
    if (!userTransactions.length) return 0;
    const priceBaht = userTransactions.reduce(
      (sum, tx) =>
        sum +
        (tx.unitName === 'บาท'
          ? tx.pricePerUnit
          : convertGold(tx.pricePerUnit, 'priceBaht', false)),
      0
    );
    return priceBaht / userTransactions.length;
  };

  return (
    <TableContainer>
      <Table size="small">
        <TableHead>
          <TableRow>
            <TableCell>ประเภท</TableCell>
            <TableCell align="right" width="25%">
              ปริมาณ
            </TableCell>
            <TableCell align="right" width="25%">
              ราคาเฉลี่ย
            </TableCell>
            <TableCell align="right" width="25%">
              รวม
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {/* Row: ซื้อ */}
          <TableRow>
            <TableCell sx={{ textAlign: 'left', verticalAlign: 'top' }}>Buy</TableCell>
            <TableCell align="right">
              <ListItemText
                primary={`${fNumber(infos.buyAmount)} กรัม`}
                secondary={`≈ ${fNumber(convertGold(infos.buyAmount, 'weightBaht', isOrnament))} บาท`}
                primaryTypographyProps={{
                  typography: 'body2',
                  noWrap: true,
                }}
                secondaryTypographyProps={{
                  component: 'span',
                  typography: 'caption',
                  noWrap: true,
                }}
              />
            </TableCell>
            <TableCell align="right" sx={{ textAlign: 'right', verticalAlign: 'top' }}>
              {infos.buyAmount > 0 ? fNumber(averagePrice()) : '0'}
            </TableCell>
            <TableCell align="right" sx={{ textAlign: 'right', verticalAlign: 'top' }}>
              {fNumber(infos.buyTotal)}
            </TableCell>
          </TableRow>

          {/* Row: ขาย */}
          <TableRow>
            <TableCell sx={{ textAlign: 'left', verticalAlign: 'top' }}>Sell</TableCell>
            <TableCell align="right">
              <ListItemText
                primary={`${fNumber(infos.sellAmount)} กรัม`}
                secondary={`≈ ${fNumber(convertGold(infos.sellAmount, 'weightBaht', isOrnament))} บาท`}
                primaryTypographyProps={{
                  typography: 'body2',
                  noWrap: true,
                }}
                secondaryTypographyProps={{
                  component: 'span',
                  typography: 'caption',
                  noWrap: true,
                }}
              />
            </TableCell>
            <TableCell align="right" sx={{ textAlign: 'right', verticalAlign: 'top' }}>
              {infos.sellAmount > 0 ? fNumber(infos.sellTotal / infos.sellAmount) : '0'}
            </TableCell>
            <TableCell align="right" sx={{ textAlign: 'right', verticalAlign: 'top' }}>
              {fNumber(infos.sellTotal)}
            </TableCell>
          </TableRow>

          {/* Row: คงเหลือสุทธิ */}
          <TableRow>
            <TableCell sx={{ textAlign: 'left', verticalAlign: 'top' }}>Net</TableCell>
            <TableCell align="right">
              <ListItemText
                primary={`${fNumber(infos.netAmount)} กรัม`}
                secondary={`≈ ${fNumber(convertGold(infos.netAmount, 'weightBaht', isOrnament))} บาท`}
                primaryTypographyProps={{
                  typography: 'body2',
                  noWrap: true,
                }}
                secondaryTypographyProps={{
                  component: 'span',
                  typography: 'caption',
                  noWrap: true,
                }}
              />
            </TableCell>
            <TableCell align="right" sx={{ textAlign: 'right', verticalAlign: 'top' }}>
              {/* {infos.netAmount > 0 ? fNumber(infos.netTotal / infos.netAmount) : '0'} */}
            </TableCell>
            <TableCell align="right" sx={{ textAlign: 'right', verticalAlign: 'top' }}>
              {fNumber(infos.netTotal)}
            </TableCell>
          </TableRow>
        </TableBody>
      </Table>
    </TableContainer>
  );
}
